module.exports = __webpack_public_path__ + "static/zircon-heart-ring-10k-yellow-gold-diamond-896f0f151e83caa94cebec882d0d4296.jpg";